// client/src/utils/auth.js
import getApiBaseUrl from "./api";
const API_URL = getApiBaseUrl();

/**
 * Ask the backend whether the current HttpOnly-cookie session is valid.
 *
 * @param {"user"|"admin"} kind
 * @returns {Promise<boolean|null>}
 *   true  -> session is valid
 *   false -> server says the session is invalid (401/403)
 *   null  -> could not determine (server down, network error, 5xx).
 *            Callers must NOT log the user out on null.
 */
export async function isTokenValid(kind = "user") {
  const path = kind === "admin" ? "/auth/admin/session" : "/auth/session";

  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "GET",
      credentials: "include",
      headers: { Accept: "application/json" },
    });

    if (response.status === 401 || response.status === 403) return false;
    if (response.ok) return true;

    // 5xx, 404, etc.: server problem, not an auth verdict
    return null;
  } catch (error) {
    console.warn("Session check skipped (server unreachable):", error.message);
    return null;
  }
}

/**
 * Clears the server-side authentication cookie.
 * The JWT is HttpOnly, so there is nothing to remove from localStorage.
 */
export async function clearExpiredSession(kind = "user") {
  const path = kind === "admin" ? "/auth/admin/logout" : "/auth/logout";

  try {
    await fetch(`${API_URL}${path}`, {
      method: "POST",
      credentials: "include",
      headers: { Accept: "application/json" },
    });
  } catch (error) {
    console.error("Logout request failed:", error);
  }
}

export async function logout(kind = "user") {
  await clearExpiredSession(kind);
}